import * as React from 'react';
import { useSelector } from 'react-redux';

import { CardSectionNew } from '../../components/CardSectionNew';
import { RosreestrInfoNew } from '../../components/RosreestrInfoNew';
import { getRosreestrInfo } from '../../selectors/offerData/getRosreestrInfo';
import { useFormattedInfo } from './hooks';

export const RosreestrInfoContainerNew: React.FC = () => {
  const rosreestrInfo = useSelector(getRosreestrInfo);

  const { formattedInfo, isSinglePart, onOpen, showOpenButton } = useFormattedInfo(rosreestrInfo);

  if (!formattedInfo) {
    return null;
  }

  return (
    <CardSectionNew>
      <RosreestrInfoNew
        {...formattedInfo}
        isSinglePart={isSinglePart}
        onOpen={onOpen}
        showOpenButton={showOpenButton}
      />
    </CardSectionNew>
  );
};
